// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SB-border.top{border-top:1px solid #e6ebed}.SB-border.right{border-right:1px solid #e6ebed}.SB-border.bottom{border-bottom:1px solid #e6ebed}.SB-border.left{border-left:1px solid #e6ebed}.border{border-color:#e6ebed!important}", ""]);
// Exports
module.exports = exports;
